// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fSD8f","textarea":"styles_textarea__39GAm"};